import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.medicationSettings;
export const medicationSettingsSelector = (state: RootState) => getState(state).data;
export const medicationSettingsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const medicationSettingsIsReadySelector = (state: RootState) => getState(state).isReady;
export const medicationSettingsErrorSelector = (state: RootState) => getState(state).error;
